import type {
  Identified,
  SoftDeletable,
  VersionedEntity
} from "../../shared/kernel/entity.js";
import type {
  ClientId,
  UserId
} from "../../shared/kernel/identifiers.js";

export enum ClientStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE"
}

export interface Client
  extends Identified<ClientId>, VersionedEntity, SoftDeletable {
  readonly name: string;
  readonly legalName: string;
  readonly document: string;
  readonly code: string;
  readonly status: ClientStatus;
  readonly createdBy: UserId | null;
  readonly updatedBy: UserId | null;
  /**
   * PLH (Profissional Legalmente Habilitado) RESPONSÁVEL TÉCNICO PRINCIPAL
   * do Cliente (Professional.id) — fonte oficial única do PLH para todos os
   * Projetos e documentos deste Cliente. Resolvida via
   * ProjectResponsibilityService.resolveClientResponsiblePlh, sempre
   * validada pelo gate isPlhQualifiedProfessional (professional.plhClientId
   * === este Cliente, ativo, ENGINEER, com assinatura cadastrada). `null`
   * é estado válido: Cliente sem PLH definido ainda.
   */
  readonly responsiblePlhProfessionalId?: string | null;
}
